const headingsForReportsGenerated = [
  "Batch ID",
  "Requested by",
  "Requested At",
  "Reports requested",
  "Status",
];

const typesOfFirmInOnboardingForm1 = [
  {
    name: "Professional Corporation",
    id: 1,
  },
  {
    name: "Sole Proprietor",
    id: 2,
  },
  {
    name: "Limited liability partnership",
    id: 3,
  },
];

const areaOfLawPracticeForm1 = [
  {
    name: "Business law (or commercial law); commercial litigation",
    id: 1,
    selected: false,
  },
  {
    name: "Construction Law",
    id: 2,
    selected: false,
  },
  {
    name: "Real estate Law",
    id: 3,
    selected: false,
  },
  {
    name: "Criminal Law",
    id: 4,
    selected: false,
  },
  {
    name: "Sports Law",
    id: 5,
    selected: false,
  },
  {
    name: "Employment Law",
    id: 6,
    selected: false,
  },
  {
    name: "Tax Law",
    id: 7,
    selected: false,
  },
  {
    name: "Entertainment Law",
    id: 8,
    selected: false,
  },
  {
    name: "Technology Law",
    id: 9,
    selected: false,
  },
  {
    name: "Environmental Law",
    id: 10,
    selected: false,
  },
  {
    name: "Trademark Law",
    id: 11,
    selected: false,
  },
  {
    name: "Family Law",
    id: 12,
    selected: false,
  },
  {
    name: "Trusts & estates Law",
    id: 13,
    selected: false,
  },
  {
    name: "Immigration Law",
    id: 14,
    selected: false,
  },
  {
    name: "Personal Injury",
    id: 15,
    selected: false,
  },
  {
    name: "Media Law",
    id: 16,
    selected: false,
  },
  {
    name: "Others",
    id: 17,
    selected: false,
  },
];

export {
  headingsForReportsGenerated,
  typesOfFirmInOnboardingForm1,
  areaOfLawPracticeForm1,
};
